import { type FC, type PropsWithChildren, useCallback, useMemo, useState } from 'react';

import { ConfirmContext, type ConfirmDialogData } from './ConfirmContext';
import { ConfirmDialog } from './ConfirmDialog';

export const ConfirmProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isConfirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [confirmDialog, setConfirmDialog] = useState<ConfirmDialogData | null>(null);

  const alert = useCallback((confirmData: ConfirmDialogData): void => {
    setConfirmDialogOpen(true);
    setConfirmDialog(confirmData);
  }, []);

  const closeDialog = (): void => setConfirmDialogOpen(false);

  const clearDialogData = (): void => setConfirmDialog(null);

  const value = useMemo(() => ({ alert }), [alert]);

  return (
    <ConfirmContext.Provider value={value}>
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        alert={confirmDialog}
        onClose={closeDialog}
        onClearDialogData={clearDialogData}
      />

      {children}
    </ConfirmContext.Provider>
  );
};
